/**
 * Session store
 * @module store/session
 */

import { createStore, createHook } from '@thermon-platforms/react-sweet-state';


// define store initial state
const initialState = {
  viewAs: sessionStorage.getItem('viewAs'),
  recentDevice: JSON.parse(sessionStorage.getItem('recentDevice') || '[]'),
  chartFidelity: Number(sessionStorage.getItem('chartFidelity')) || 1,
  devicesListWidth: Number(sessionStorage.getItem('devicesListWidth')) || 300
};
// define the actions that mutate the state
export const actions = {
  setViewAs: (viewAs) => ({ setState }) => {
    sessionStorage.setItem('viewAs', viewAs);
    setState({ viewAs });
  },
  setRecentDevice: (path) => ({ setState }) => {
    sessionStorage.setItem('recentDevice', JSON.stringify(path));
    setState({ recentDevice: path });
  },
  setChartFidelity: (fidelity) => ({ setState }) => {
    sessionStorage.setItem('chartFidelity', fidelity);
    setState({ chartFidelity: fidelity });
  },
  setDevicesListWidth: (width) => ({ setState }) => {
    sessionStorage.setItem('devicesListWidth', width);
    setState({ devicesListWidth: width });
  }
}

// create a store type
const Store = createStore({ initialState, actions });

// create components to access store state instances
const useStore = createHook(Store);

/**
 * Expose hooks for store
 * @function useStore
 * @memberof module:store/session
 *
 * @example
 * const [sessionStore, sessionStoreActions] = useSessionStore();
 *
 */
export default useStore;
